var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    className: "jss97 jss6501",
    focusable: "false",
    viewBox: "0 0 30 30",
    "aria-hidden": "true",
    "data-fill-none": "true",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_64)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 15.0733C27 21.0996 22.6116 26.0945 16.875 27V18.5633H19.6711L20.2031 15.0733H16.875V12.8086C16.875 11.8536 17.34 10.9231 18.8306 10.9231H20.3438V7.95195C20.3438 7.95195 18.9703 7.71615 17.6573 7.71615C14.9166 7.71615 13.125 9.38755 13.125 12.4134V15.0733H10.0781V18.5633H13.125V27C7.38844 26.0945 3 21.0996 3 15.0733C3 8.40565 8.37281 3 15 3C21.6272 3 27 8.40565 27 15.0733Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6711 18.4688L20.2031 15H16.875V12.749C16.875 11.8 17.3399 10.875 18.8306 10.875H20.3438V7.92188C20.3438 7.92188 18.9705 7.6875 17.6576 7.6875C14.9165 7.6875 13.125 9.34875 13.125 12.3563V15H10.0781V18.4688H13.125V26.8542C13.736 26.95 14.3621 27 15 27C15.6379 27 16.264 26.95 16.875 26.8542V18.4688H19.6711Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.d89a31710385a0cd42469aa4de7444f6.svg";
export { ForwardRef as ReactComponent };